export default __webpack_public_path__ + "static/media/addFolder.be30dca1.PNG";